import { render, staticRenderFns } from "./icon-btn.vue?vue&type=template&id=9fe4cdba&scoped=true&"
import script from "./icon-btn.vue?vue&type=script&lang=ts&"
export * from "./icon-btn.vue?vue&type=script&lang=ts&"
import style0 from "./icon-btn.vue?vue&type=style&index=0&id=9fe4cdba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe4cdba",
  null
  
)

export default component.exports